import { DatePicker } from "antd";
import MenuLayout from "components/CustomFilterMenu/MenuLayout";
import moment from "moment";
import { useState } from "react";

import { endOfDayMomentToISOString, startOfDayMomentToISOString } from "utils/dateTime";

function toMomentRange(range) {
  if (!range?.from && !range?.to) return [];
  const start = range.from ? moment(range.from) : null;
  const end = range.to ? moment(range.to) : null;
  if (start && end) return [start, end];
  if (start) return [start, start];
  return [];
}

export default function DateRangeColumnFilter({ onFilter, defaultValue }) {
  const [value, setValue] = useState(() => toMomentRange(defaultValue));

  const handleReset = () => {
    setValue([]);
    onFilter?.(null);
  };

  const handleApply = () => {
    if (!value?.length || !value[0]) {
      onFilter?.(null);
      return;
    }
    const end = value[1] || value[0];
    onFilter({
      from: startOfDayMomentToISOString(value[0]),
      to: endOfDayMomentToISOString(end),
    });
  };

  return (
    <MenuLayout
      style={{ width: 320 }}
      filterContent={<DatePicker.RangePicker value={value} onChange={setValue} style={{ width: "100%" }} />}
      resetFilter={handleReset}
      applyFilter={handleApply}
    />
  );
}
